import { render, staticRenderFns } from "./CreateContentAssignment.vue?vue&type=template&id=4760898f"
import script from "./CreateContentAssignment.vue?vue&type=script&lang=ts"
export * from "./CreateContentAssignment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports